import React, { useState, useEffect } from 'react';
import { userAPI } from '../../services/api';
import Filter from '../../components/ui/Filter';

const RapprochementFilters = ({ filters, onFiltersChange, onReset }) => {
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    userAPI.getManagerUsers()
      .then((res) => {
        setManagers(
          (res.data || []).map((m) => ({
            value: m.id,
            label: `${m.firstName} ${m.lastName}`.trim(),
          }))
        );
      })
      .catch((err) => console.error('Error loading managers:', err));
  }, []);

  const filterConfig = [
    {
      name: 'searchTerm',
      type: 'search',
      placeholder: 'Recherche...',
    },
    {
      name: 'createdByIds',
      type: 'dropdown',
      label: 'Par',
      placeholder: 'Tous',
      options: managers,
      isMultiSelect: true,
    },
    {
      name: 'dateRange',
      type: 'daterange',
      placeholder: 'Date',
    },
  ];

  const handleFilterChange = (name, value) => {
    onFiltersChange({ ...filters, [name]: value });
  };

  return (
    <Filter
      filters={filterConfig}
      filterValues={filters}
      onFilterChange={handleFilterChange}
      onReset={onReset}
      columns={3}
    />
  );
};

export default RapprochementFilters;
